import { Input, OnInit, Component, Output, EventEmitter, WritableSignal, signal } from '@angular/core'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'
import { DateTime } from 'luxon'
import { CreditCard } from 'angular-cc-library'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { CreditCardDirectivesModule } from 'angular-cc-library'
import { CardInfo } from 'src/types/billing'

@Component({
	selector: 'gwc-credit-card-form',
	templateUrl: './credit.card.form.component.html',
	styleUrls: ['./credit.card.form.component.scss'],
	imports: [
		CreditCardDirectivesModule,
		ReactiveFormsModule,
		MatInputModule,
		MatSelectModule,
		NgxMaskDirective,
	],
	providers: [
		provideNgxMask()
	]
})

export class CreditCardFormComponent implements OnInit {
	@Input() ccForm!: FormGroup
	@Output() cardInfo = new EventEmitter<CardInfo>()
	
	public expirationYears: WritableSignal<string[]> = signal([])
	public expirationMonths: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
	public cardIcon: WritableSignal<string> = signal('generic.svg')
	public cardTypes = [
		'visa',
		'mastercard',
		'amex',
		'dinersclub',
		'discover',
		'jcb',
		'unionpay',
		'maestro',
		'elo',
	]

	ngOnInit() {
		this.initiateYears()
	}

	private initiateYears(): void {
		const yearsAmount = 10
		const currentYear = DateTime.now()
		let years: string[] = []

		for (let i = 0; i < yearsAmount; i += 1) {
			years.push(currentYear.plus({years: i}).toFormat('y'))
		}

		this.expirationYears.set(years)
	}
 
	public getCreditCardIcon() {
		const type = CreditCard.cardType(this.ccForm.get('number')?.value)
		this.cardIcon.set(!!type && this.cardTypes.includes(type)
			? type + '.svg'
			: 'generic.svg')
	}
}
